import { LocalAudioTrack } from 'twilio-video';

import { isIOS } from '@growtherapy/analytics';

import { LocalAudioDelegator } from '../../../../core/room/participant/media/MediaDelegator';

export class TwilioLocalAudioDelegator implements LocalAudioDelegator {
  readonly kind = 'audio' as const;
  #track: LocalAudioTrack;

  constructor(audioTrack: LocalAudioTrack) {
    this.#track = audioTrack;
  }

  get deviceId() {
    return this.#track.mediaStreamTrack.getSettings().deviceId;
  }

  get isEnabled() {
    return !!this.#track.isEnabled;
  }

  // Twilio-specific instance methods
  get track() {
    return this.#track;
  }

  get mediaStream() {
    const mediaStreamTrack = this.#track.mediaStreamTrack;

    // clone the mediaStreamTrack on iOS
    // https://github.com/twilio/twilio-video-app-react/blob/master/src/components/AudioLevelIndicator/AudioLevelIndicator.tsx#L47
    return new MediaStream([isIOS(navigator.userAgent) ? mediaStreamTrack.clone() : mediaStreamTrack]);
  }
}
